import { render } from "./form-part-b-specific-power-money.html?vue&type=template&id=635c21d8&scoped=true&ts=true&external"
import script from "./form-part-b-specific-power-money.ts?vue&type=script&lang=ts&external"
export * from "./form-part-b-specific-power-money.ts?vue&type=script&lang=ts&external"

import "./form-part-b-specific-power-money.scss?vue&type=style&index=0&id=635c21d8&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635c21d8"]])

export default __exports__